/**
 * Constantes liées aux rôles applicatifs — extraites de RoleContext.tsx
 * pour que le Provider reste un fichier "components-only" (React Fast Refresh
 * ne gère pas bien le HMR quand un fichier mélange composants et constantes).
 */

/**
 * ⚠️ `publication_photos` et `publication_suivi` ont été retirés le 2026-08-10.
 * Ce n'étaient pas des rôles utilisateur — l'enum Postgres `user_role` vaut
 * `admin, c_level, collaborateur, publication, prestataire, autre` et ne les a
 * jamais contenus — mais deux lignes de `field_permissions` atteignables par un
 * remap de chemin devenu mort. La migration 113 a fusionné leurs droits dans
 * `publication`, la 114 a supprimé leurs lignes.
 *
 * `collaborateur_els` et `collaborateur_afr` restent, eux : leur remap est
 * inconditionnel et bien vivant (cf. `useBiensPermRole`).
 */
export type AppRole =
  | "admin"
  | "c_level"
  | "collaborateur"
  | "collaborateur_els"
  | "collaborateur_afr"
  | "vente"
  | "publication"
  | "prestataire"
  | "autre";

export const ROLE_LABELS: Record<AppRole, string> = {
  admin: "Admin",
  c_level: "C. Level",
  collaborateur: "Collaborateur",
  collaborateur_els: "Collab. ELS",
  collaborateur_afr: "Collab. AFR",
  vente: "Sales",
  publication: "Publication",
  prestataire: "Prestataire",
  autre: "Autre",
};

/** Rôles utilisateur pour le role switcher */
export const ALL_ROLES: AppRole[] = ["admin", "c_level", "collaborateur", "vente", "publication", "prestataire", "autre"];
export const NON_ADMIN_ROLES: AppRole[] = ["c_level", "collaborateur", "vente", "publication", "prestataire", "autre"];

/**
 * Rôles pour l'ancienne matrice de permissions admin (onglet « Droits des
 * champs » d'une fiche). `collaborateur` y reste splitté en ELS/AFR — les deux
 * lignes existent toujours ; `publication` n'y est plus splitté depuis la
 * migration 114.
 */
export const PERMISSION_ROLES: AppRole[] = ["admin", "c_level", "collaborateur_els", "collaborateur_afr", "vente", "publication", "prestataire", "autre"];
